import {BadgeCounter} from '@mdsol/onex-design'
import React from 'react'
import {FC} from 'react'
import {CellPropsType} from './cellPropsType'

const Total: FC<CellPropsType> = ({cell}) => {
  const value = cell.getValue()
  return (
    <BadgeCounter
    >
      {value.toLocaleString('en-US')}
    </BadgeCounter>
  )
}

export default Total
